import React from 'react'
import classNames from 'classnames/bind'
import styles from './KpiCard.module.scss'
import type { KpiVariant } from '../types'

const cx = classNames.bind(styles)

interface KpiCardProps {
  label: string
  value: number
  eyebrow: string
  variant: KpiVariant
  icon: React.ReactNode
}

export default function KpiCard({ label, value, eyebrow, variant, icon }: KpiCardProps) {
  return (
    <article className={cx('kpiCard', `kpiCard--${variant}`)}>
      <div className={cx('kpiTop')}>
        <div className={cx('kpiIdentity')}>
          <div className={cx('kpiIcon', `kpiIcon--${variant}`)}>{icon}</div>
          <div className={cx('kpiLabel')}>{label}</div>
        </div>
      </div>
      <div className={cx('kpiValue')}>{value.toLocaleString()}</div>
      <div className={cx('kpiCompare')}>{eyebrow}</div>
    </article>
  )
}
